import $foreign from "./foreign.cjs";
var intSub = $foreign.intSub;
var numSub = $foreign.numSub;
export { intSub, numSub };
